import axios from 'axios';

const validar = (idSolicitacao, token) => axios.post(`external/validate/${idSolicitacao}`, token);
const validarFinalizacao = (idSolicitacao, token) => axios.post(`external/validate/finalizacao/${idSolicitacao}`, token);

export default {
  validar,
  validarFinalizacao,
};
